export type HubspotSubmissionKind = 'new' | 'update';

function normalizeRequestType(value: string | null | undefined): string {
  return (
    value
      ?.trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '') ?? ''
  );
}

function getRequestTypeSubmissionKind(
  requestType: string | null | undefined,
): HubspotSubmissionKind | null {
  const normalized = normalizeRequestType(requestType);

  if (!normalized) {
    return null;
  }

  if (normalized.includes('support') || normalized.includes('remove')) {
    return null;
  }

  if (
    normalized === 'update1' ||
    normalized === 'updaterelease' ||
    normalized === 'updatedapp' ||
    normalized.startsWith('update')
  ) {
    return 'update';
  }

  if (
    normalized === 'submit1' ||
    normalized === 'newrelease' ||
    normalized === 'newdapp' ||
    normalized.startsWith('submit') ||
    normalized.startsWith('new')
  ) {
    return 'new';
  }

  return null;
}

function getContentSubmissionKind(
  content: string | null | undefined,
): HubspotSubmissionKind | null {
  if (!content) {
    return null;
  }

  const header = content.match(
    /^(New Release Submission|Release Update Submission|New Dapp Submission):/m,
  )?.[1];
  const submissionType = content
    .match(/^Submission Type:\s*(.+)$/m)?.[1]
    ?.trim()
    .toLowerCase();

  if (
    header === 'Release Update Submission' ||
    submissionType?.includes('update')
  ) {
    return 'update';
  }

  if (
    header === 'New Release Submission' ||
    header === 'New Dapp Submission' ||
    submissionType?.includes('initial')
  ) {
    return 'new';
  }

  return null;
}

export function getHubspotSubmissionKind(input: {
  requestType: string | null | undefined;
  content: string | null | undefined;
  hasPublishedReleaseHistory?: boolean | null | undefined;
}): HubspotSubmissionKind | null {
  const inferredKind =
    getRequestTypeSubmissionKind(input.requestType) ||
    getContentSubmissionKind(input.content);

  if (inferredKind === 'update' && input.hasPublishedReleaseHistory === false) {
    return 'new';
  }

  return inferredKind;
}

export function getHubspotSubmissionKindLabel(
  kind: HubspotSubmissionKind,
): string {
  return kind === 'new' ? 'New Submission' : 'Update';
}
